/** Semantic tone for data-viz fills, borders, and series — four state tokens only. */
export type VizTone = 'ok' | 'warn' | 'bad' | 'neutral' | 'info';

export function vizToneColor(tone: VizTone): string {
  switch (tone) {
    case 'ok':
      return 'var(--state-online)';
    case 'warn':
      return 'var(--state-warning)';
    case 'bad':
      return 'var(--state-blocked)';
    case 'info':
      return 'var(--state-info)';
    default:
      return 'var(--ink-tertiary)';
  }
}
